import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsSpecialNeedsTrustInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/special-needs-trust-in-new-york/']} />;
}
